import { Injectable } from '@angular/core';
import { ExpandMode } from './expand-mode';
export class TreeSelectDefaultOptions {
public allowFilter?: boolean;
public filterPlaceholder?: string;
public maxVisibleItemCount?: number;
public allowParentSelection?: boolean;
public idField?: string;
public textField?: string;
public childrenField?: string;
public filterCaseSensitive?: boolean;
public expandMode = ExpandMode.None;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TreeSelectDefaultOptions_tsickle_Closure_declarations() {
/** @type {?} */
TreeSelectDefaultOptions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TreeSelectDefaultOptions.ctorParameters;
/** @type {?} */
TreeSelectDefaultOptions.prototype.allowFilter;
/** @type {?} */
TreeSelectDefaultOptions.prototype.filterPlaceholder;
/** @type {?} */
TreeSelectDefaultOptions.prototype.maxVisibleItemCount;
/** @type {?} */
TreeSelectDefaultOptions.prototype.allowParentSelection;
/** @type {?} */
TreeSelectDefaultOptions.prototype.idField;
/** @type {?} */
TreeSelectDefaultOptions.prototype.textField;
/** @type {?} */
TreeSelectDefaultOptions.prototype.childrenField;
/** @type {?} */
TreeSelectDefaultOptions.prototype.filterCaseSensitive;
/** @type {?} */
TreeSelectDefaultOptions.prototype.expandMode;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
